module.exports = __webpack_public_path__ + "static/media/janed.99c647d6.png";